import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations } from './configurations';
import { apiAction as checkEventRegistered } from './configurations/checkEventRegistered';
import { apiAction as get } from './configurations/get';
import { apiAction as getById } from './configurations/getById';
import { apiAction as getRecommended } from './configurations/getRecommended';
import { apiAction as setNotAttendCourse } from './configurations/setNotAttendCourse';

export const apiActions = {
  event: {
    get,
    getById,
    getRecommended,
    checkEventRegistered,
    setNotAttendCourse
  }
}

const actions = mapActionsFromConfigurations('event')(configurations);

export { API_ENDPOINT } from './configurations/endpoints';

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/event/actions.js